<dashboard-dialog-frame [header]="'Add Entrepreneur'" [dialogRef]='dialogRef' [actions]="actions()">

	<div class="p-3">
		<person-finder-widget searchLabel='Search Person' (selectedRowId)="setSelectedPersonId($event)"></person-finder-widget>

		@if(assignedVentures(); as assignedVentures){
		<div class="my-3">
			@if(assignedVentures.length === 0){
			<div class="text-success">Looks good! Continue adding this person to {{dialogContext.data?.ventureName}}?</div>
			} @else {
			<div class="text-danger">
				@if(assignedParticipatingOrGraduatedVenture(); as participatingOrGraduatedVenture){
				<p>Cannot Add. This entrepreneur is already associated with a venture {{participatingOrGraduatedVenture.assignedVentureName}} with a status of {{participatingOrGraduatedVenture.assignedVentureStatus}}.</p>
				<p>If you still wish to add this entrepreneur, remove them from the {{participatingOrGraduatedVenture.assignedVentureName}} venture.</p>

				} @else {
				<p>This person record already is associated with an Accelerator Venture(s): {{assignedVentureInfo()?.names}}, in the status of {{assignedVentureInfo()?.statuses}}.</p>
				<p>Do you wish to continue adding a second record for this entrepreneur to {{dialogContext.data?.ventureName}}?</p>
				}
			</div>
			}
		</div>
		}
	</div>

</dashboard-dialog-frame>